// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "settlement.proto" (package "transaction", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { SettlementService } from "./settlement";
import type { RecordSettlementTransactionResponse } from "./settlement";
import type { RecordSettlementTransactionRequest } from "./settlement";
import type { DeleteSettlementResponse } from "./settlement";
import type { DeleteSettlementRequest } from "./settlement";
import type { ConfirmSettlementResponse } from "./settlement";
import type { ConfirmSettlementRequest } from "./settlement";
import type { UpdateSettlementResponse } from "./settlement";
import type { UpdateSettlementRequest } from "./settlement";
import type { CreateSettlementResponse } from "./settlement";
import type { CreateSettlementRequest } from "./settlement";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetAllSettlementsResponse } from "./settlement";
import type { GetAllSettlementsRequest } from "./settlement";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service transaction.SettlementService
 */
export interface ISettlementServiceClient {
    /**
     * @generated from protobuf rpc: GetAllSettlements
     */
    getAllSettlements(input: GetAllSettlementsRequest, options?: RpcOptions): UnaryCall<GetAllSettlementsRequest, GetAllSettlementsResponse>;
    /**
     * @generated from protobuf rpc: CreateSettlement
     */
    createSettlement(input: CreateSettlementRequest, options?: RpcOptions): UnaryCall<CreateSettlementRequest, CreateSettlementResponse>;
    /**
     * @generated from protobuf rpc: UpdateSettlement
     */
    updateSettlement(input: UpdateSettlementRequest, options?: RpcOptions): UnaryCall<UpdateSettlementRequest, UpdateSettlementResponse>;
    /**
     * @generated from protobuf rpc: ConfirmSettlement
     */
    confirmSettlement(input: ConfirmSettlementRequest, options?: RpcOptions): UnaryCall<ConfirmSettlementRequest, ConfirmSettlementResponse>;
    /**
     * @generated from protobuf rpc: DeleteSettlement
     */
    deleteSettlement(input: DeleteSettlementRequest, options?: RpcOptions): UnaryCall<DeleteSettlementRequest, DeleteSettlementResponse>;
    /**
     * @generated from protobuf rpc: RecordSettlementTransaction
     */
    recordSettlementTransaction(input: RecordSettlementTransactionRequest, options?: RpcOptions): UnaryCall<RecordSettlementTransactionRequest, RecordSettlementTransactionResponse>;
}
/**
 * @generated from protobuf service transaction.SettlementService
 */
export class SettlementServiceClient implements ISettlementServiceClient, ServiceInfo {
    typeName = SettlementService.typeName;
    methods = SettlementService.methods;
    options = SettlementService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetAllSettlements
     */
    getAllSettlements(input: GetAllSettlementsRequest, options?: RpcOptions): UnaryCall<GetAllSettlementsRequest, GetAllSettlementsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAllSettlementsRequest, GetAllSettlementsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateSettlement
     */
    createSettlement(input: CreateSettlementRequest, options?: RpcOptions): UnaryCall<CreateSettlementRequest, CreateSettlementResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateSettlementRequest, CreateSettlementResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSettlement
     */
    updateSettlement(input: UpdateSettlementRequest, options?: RpcOptions): UnaryCall<UpdateSettlementRequest, UpdateSettlementResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateSettlementRequest, UpdateSettlementResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ConfirmSettlement
     */
    confirmSettlement(input: ConfirmSettlementRequest, options?: RpcOptions): UnaryCall<ConfirmSettlementRequest, ConfirmSettlementResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConfirmSettlementRequest, ConfirmSettlementResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteSettlement
     */
    deleteSettlement(input: DeleteSettlementRequest, options?: RpcOptions): UnaryCall<DeleteSettlementRequest, DeleteSettlementResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteSettlementRequest, DeleteSettlementResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RecordSettlementTransaction
     */
    recordSettlementTransaction(input: RecordSettlementTransactionRequest, options?: RpcOptions): UnaryCall<RecordSettlementTransactionRequest, RecordSettlementTransactionResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<RecordSettlementTransactionRequest, RecordSettlementTransactionResponse>("unary", this._transport, method, opt, input);
    }
}
